<template>
  <div
    class="input-group"
    style="margin-bottom: 0"
  >
    <div
      class="enable"
      :data-checkbox="dataset"
      :class="[
        validationClass,
        animationErrorClass,
        value
          ? `${classes} checked`
          : classes,
      ]"
      @click="onToggle"
    >
      <div class="checkbox__title">
        <slot /> <span v-if="required" class="required">*</span>
      </div>
      <div :class="validationClass" />
    </div>
    <div v-if="isShow && error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { mixins } from 'cms3-shop-module-ts'
export default {
  mixins: [mixins.UiCheckbox],

  props: {
    /**
     * * Значение с инпута
     */
    value: {
      type: Boolean,
      required: true,
      default: () => true
    },

    /**
     * * Присваемые классы к чекбоксу
     */
    classes: {
      type: String,
      default: () => 'checkbox'
    },

    /**
     * * Обязательный ли чекбокс ?
     */
    required: {
      type: Boolean,
      default: false
    },

    /**
     * * Набор данных
     */
    dataset: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.switch-no-cheked {
  background: #CFDBE9;
}
.enable {
  user-select: none;
}
.required {
  color: #e1262d;
}

.form-error {
  bottom: -32px
}

::v-deep.input-group {
  .error {
    border-color: #f0b6b8;
    background-color: unset;
    color: unset;
  }

  .valid {
    background-color: unset;
  }
}
</style>
